import React, { useState } from "react";
import { createRoot } from "react-dom/client";
import { HelmetProvider } from "react-helmet-async";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  useParams,
  Link,
} from "react-router-dom";
import PortfolioForm from "./PortfolioForm";
import Passionate from "./pages/Passionate";
import PortfolioRegForm from "./components/PortfolioRegForm";
import Modal from "./components/Modal";
import PortfolioPage from './pages/PortfolioPage';
import LiveClientPortal from './pages/LiveClientPortal';
import AdminPanel from "./components/AdminPanel"; 
import FrontPage from './components/FrontPage';
import Header from './components/Header';
import Main from './components/Main';
import Footer from './components/Footer';
import './App.css';
import SignupForm from './components/SignupForm';
import LoginForm from './components/LoginForm';
import MobileBottomNav from './components/MobileBottomNav'; // ✅ added this line
import ImageSwiper from './components/ImageSwiper';
import RankingsPage from "./components/RankingsPage";  // ✅ Import the RankingsPage

function Home() {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isLoginOpen, setLoginOpen] = useState(false);
  const [isSignupOpen, setSignupOpen] = useState(false);

  const openModal = () => setIsModalOpen(true);
  const closeModal = () => setIsModalOpen(false);

  const openLoginForm = () => setLoginOpen(true);
  const closeLoginForm = () => setLoginOpen(false);

  const openSignupForm = () => setSignupOpen(true);
  const closeSignupForm = () => setSignupOpen(false);

  return (
    <div className="text-center p-8 space-y-6">
      <h1 className="text-3xl font-bold text-blue-700">Welcome to Flourish Talents</h1>
      <p className="text-gray-700">This is the homepage. Navigate to a form using the link below.</p>

      <div className="space-x-4">
        <button
          onClick={openModal}
          className="bg-green-600 text-white px-4 py-2 rounded-lg hover:bg-green-700"
        >
          Apply Now
        </button>
        <button
          onClick={openLoginForm}
          className="bg-blue-600 text-white px-4 py-2 rounded-lg hover:bg-blue-700"
        >
          Login
        </button>
        <button
          onClick={openSignupForm}
          className="bg-purple-600 text-white px-4 py-2 rounded-lg hover:bg-purple-700"
        >
          Sign Up
        </button>
      </div>

      {/* ✅ Modals */}
      <Modal isOpen={isModalOpen} closeModal={closeModal}>
        <PortfolioRegForm closeModal={closeModal} />
      </Modal>

      <Modal isOpen={isLoginOpen} closeModal={closeLoginForm}>
        <LoginForm onLoginSuccess={closeLoginForm} />
      </Modal>

      <Modal isOpen={isSignupOpen} closeModal={closeSignupForm}>
        <SignupForm onSignupSuccess={closeSignupForm} />
      </Modal>

      <p className="text-gray-600">Or navigate to a form:</p>
      <ul className="list-disc list-inside text-left inline-block text-gray-800">
        <li><Link to="/form/portfolio-form" className="text-blue-500 hover:underline">Go to Portfolio Form</Link></li>
      </ul>
    </div>
  );
}

function DynamicFormPage() {
  const { formType } = useParams();

  if (formType === "portfolio-form") return <PortfolioForm />;

  return <div className="text-center text-red-600 font-semibold">Form not found.</div>;
}

// Home component is your main landing page (if used)
function App() {
  return (
    <HelmetProvider>
     <Router>
      <div className="App">
        {/* Hidden Swiper - Keeps swiping logic globally available without showing it visually */}
        <div style={{ position: 'absolute', width: 0, height: 0, overflow: 'hidden' }}>
          <ImageSwiper isVisible={false} />
        </div>

        {/* Navigation bar that will be visible on all pages */}
        <MobileBottomNav />

        {/* Routes */}
        <Routes>
          <Route path="/" element={<Main />} />
          <Route path="/form/:formType" element={<DynamicFormPage />} />
          <Route path="/portfolio/:username" element={<PortfolioPage />} />
          <Route path="/portal/:username" element={<LiveClientPortal />} />
          <Route path="/passionate" element={<Passionate />} />
          <Route path="/frontpage" element={<FrontPage />} />
          <Route path="/header" element={<Header />} />
          <Route path="/main" element={<Main />} />
          <Route path="/footer" element={<Footer />} />
          <Route path="/admin" element={<AdminPanel />} />
          <Route path="/rankings" element={<RankingsPage />} /> {/* ✅ Added RankingsPage route */}
        </Routes>
      </div>
    </Router>
    </HelmetProvider>
  );
}

const rootElement = document.getElementById("root");
const root = createRoot(rootElement);
root.render(<App />);

export default App;
